export const initialState = {
  list: [],
  single: null,
};
